
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointNextIec as ObiWaypointNextIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-next-iec.js';
 
 
 

 
 export const ObiWaypointNextIec = createComponent({
   react: React,
   tagName: 'obi-waypoint-next-iec',
   elementClass: ObiWaypointNextIecElement,
   events: {
     
   }
  });
 
 